export const Newsletter = () => {
	$('#mc-newsletter-form, #cyber-newsletter-form, #cyber-v2-newsletter-form').on('submit', (e) => {
		e.preventDefault();

		let validRegex =
			/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

		let nonce = $('#newsletter-nonce').val();
		let email = $('.signup-form #email').val();
		let referring_site = window.location.href;
		let formId = e.target.id;

		if (email.match(validRegex)) {
			console.log(formId);
			$.ajax({
				type: 'post',
				dataType: 'json',
				url: wp_ajax.ajaxurl,
				data: {
					action: 'lsvp_newsletter',
					nonce,
					email,
					referring_site,
					formId,
				},
				success: (result) => {
					$('.signup-form #email').parent().removeClass('invalid');
					$('.signup-form #email').parent().addClass('success');
				},
				error: (result) => {
					showError('Error: Please try again later');
					console.log(result);
				},
			});
		} else {
			showError('Invalid email address');
		}
	});
};

const showError = (msg) => {
	let $field = $('.signup-form #email');
	$field.parent().addClass('invalid');
	$field.parent().removeClass('success');
	$field.val('');
	$field.attr('placeholder', msg);
};
